import React from 'react'
import AddBoxIcon from '@material-ui/icons/AddBox';
import CustomToolButton from './CustomToolButton'

const AddToolButton = ({handleClick}) => {
    return <CustomToolButton toolTip="Add New" handleClick={handleClick} IconComp={AddBoxIcon} />
}

export default AddToolButton